import { useState, useMemo, useEffect } from 'react'

export function useProjectSearch(projects, selectedProjectId) {
  const [searchInput, setSearchInput] = useState('')
  const [showMenu, setShowMenu] = useState(false)

  // Map projects to ComboBox options format
  const allProjectOptions = useMemo(() => {
    return projects?.map((project) => ({
      label: project.name,
      value: project.id,
    })) ?? []
  }, [projects])

  // Filter options based on search input
  const filteredOptions = useMemo(() => {
    if (!searchInput || searchInput.trim() === '') {
      return allProjectOptions
    }
    
    const searchLower = searchInput.toLowerCase()
    return allProjectOptions.filter((option) =>
      option.label.toLowerCase().includes(searchLower)
    )
  }, [searchInput, allProjectOptions])

  // Set initial input value based on selected project
  useEffect(() => {
    if (selectedProjectId && allProjectOptions.length > 0) {
      const selectedProject = allProjectOptions.find(
        (opt) => opt.value === selectedProjectId
      )
      if (selectedProject) {
        setSearchInput(selectedProject.label)
      }
    } else {
      setSearchInput('')
    }
  }, [selectedProjectId, allProjectOptions])

  const handleInputChange = (value) => {
    setSearchInput(value ?? '')
    setShowMenu(true)
  }

  const handleSelect = (option) => {
    setSearchInput(option.label)
    setShowMenu(false)
    return option.value
  }

  const handleMenuToggle = (isOpen) => {
    setShowMenu(isOpen)
  }

  const handleFocus = () => {
    setShowMenu(true)
  }

  const handleBlur = () => {
    // Reset to selected project name if input doesn't match any project
    if (selectedProjectId && allProjectOptions.length > 0) {
      const selectedProject = allProjectOptions.find(
        (opt) => opt.value === selectedProjectId
      )
      if (selectedProject && searchInput !== selectedProject.label) {
        setSearchInput(selectedProject.label)
      }
    } else if(!selectedProjectId) {
        setSearchInput('')
    }
    setShowMenu(false)
  }

  return {
    searchInput,
    filteredOptions,
    showMenu,
    handleInputChange,
    handleSelect,
    handleMenuToggle,
    handleFocus,
    handleBlur,
  }
}